<template>
    <div class="p-4">
        <h1>Page Not Found</h1>
        <p>Please check if the URL you have entered is correct.</p>
    </div>
</template>